import jQuery from 'jquery';

window.jQuery = jQuery;

require('bootstrap');

(function($) {
  $('[data-toggle="dropdown"]').dropdown();
  $('[data-toggle="tab"]').on('click', function(e) {
    e.preventDefault();
    $(this).tab('show');
  });

  $('body').on('click', '.clickable', function(e) {
    const link = $(this)
      .find('a:not([href=""])')
      .first();

    if (link) {
      e.preventDefault();
      if (link.attr('target') === '_blank') {
        window.open(link.attr('href'), '_blank');
        return false;
      }
      window.location.assign(link.attr('href'));
      return false;
    }

    return true;
  });

  // $('.btn[href^="#"]').click(function(event){
  //   const hashBtn = $($(this).attr('href'));
  //   const offset = parseInt($(this).data('offset')) || 0;
  //   if(hashBtn.length > 0){
  //     event.preventDefault();
  //     $('html, body').animate({
  //       scrollTop: hashBtn.offset().top + offset
  //     }, 500);
  //   }
  // });

  $('body').on('click', '.btn[href^="#"]', function(event) {
    const hashBtn = $($(this).attr('href'));
    const offset = parseInt($(this).data('offset')) || -50;

    if (hashBtn.length > 0) {
      event.preventDefault();
      $('html, body').animate(
        {
          scrollTop: hashBtn.offset().top + offset
        },
        500
      );

      $('body').removeClass('nav-mobile-submenu--open nav-mobile--open');
    }
  });

  $('body').on('click', '[href="#live-chat"]', function(event) {
    event.preventDefault();

    const chatButton = document.querySelector('.helpButtonEnabled');

    if (chatButton) {
      chatButton.click();
    } else {
      window.location.assign('https://help.burstsms.com/s/submit-ticket');
    }
  });

  function getURLParams(url) {
    const params = new URLSearchParams(new URL(url).search);
    return Object.fromEntries(params.entries());
  }
  
  function appendUTMParamsToLinks() {
    const links = document.querySelectorAll("a[href*='register.burstsms.com']");
    const urlParams = getURLParams(window.location.href);
  
    for (const link of links) {
      const linkURL = new URL(link.href);
      const linkParams = getURLParams(linkURL.href);
  
      for (const [param, value] of Object.entries(urlParams)) {
        if (param.startsWith('utm_') && !linkParams.hasOwnProperty(param)) {
          linkURL.searchParams.set(param, value);
        }
      }
  
      link.href = linkURL.href;
    }
  }
  
  window.addEventListener('load', appendUTMParamsToLinks);
})(jQuery);
